import { Injectable } from '@angular/core';

import { AzavistaApiService, IDependency, convertDependencyToV2 } from '@azavista/servicelib';
import { IField, IRowAction } from '@azavista/components/shared';
import { DependencyRowActionId } from './enums';
import { ICalculatedDependencyRow } from './interfaces';
import { getDependencyEventActivityIds, getDependencyEventProductFields, getDependencyWorkflow } from 'src/app/event/website/dependencies/dependencies.service';
import { SharedService } from 'src/app/shared/shared.service';
import { TranslationKey } from 'src/app/shared/enums';
import { IconName } from 'src/app/shared/icons-enum';

@Injectable({
    providedIn: 'root'
})
export class DependenciesPopupService {
    constructor(private sharedSvc: SharedService, private apiSvc: AzavistaApiService) {
    }

    addEventStartAndEndDatesFields(fields: IField[]): void {
        const eventStartDateField = {
            id: 'Event.start', name: 'Event.start', label: this.sharedSvc.translate(TranslationKey.eventStart),
            schema: { type: 'string', format: 'date-time' }
        } as IField;
        const eventEndDateField = {
            id: 'Event.end', name: 'Event.end', label: this.sharedSvc.translate(TranslationKey.eventEnd),
            schema: { type: 'string', format: 'date-time' }
        } as IField;
        fields.push(eventStartDateField);
        fields.push(eventEndDateField);
    }

    getDependencyActions(): IRowAction[] {
        const result: IRowAction[] = [{
            label: this.sharedSvc.translate(TranslationKey.viewOrEdit),
            id: DependencyRowActionId.viewOrEdit, icon: IconName.edit, singleSelectionOnly: true
        }, {
            label: this.sharedSvc.translate(TranslationKey.delete),
            id: DependencyRowActionId.delete, icon: IconName.style, singleSelectionOnly: true
        }];
        return result;
    }

    getDependenciesDisplayedColumns(): string[] {
        return this.getDependenciesColumns().map(x => x.name);
    }

    getDependenciesColumns(): IField[] {
        const result: IField[] = [];
        result.push({
            id: 'name', name: 'name', label: this.sharedSvc.translate(TranslationKey.name), category: '',
            schema: { type: 'string' }, editable: false, builtin: true, visible_for_planners: true
        });
        result.push({
            id: 'criteriaCount', name: 'criteriaCount', label: this.sharedSvc.translate(TranslationKey.criteria), category: '',
            schema: { type: 'integer' }, editable: false, builtin: true, visible_for_planners: true
        });
        return result;
    }

    convertToCalculatedDependencyRows(dependencies: IDependency[]): ICalculatedDependencyRow[] {
        const calculatedRows: ICalculatedDependencyRow[] = [];
        for (const dependency of dependencies) {
            const dependencyV2 = convertDependencyToV2(dependency);
            calculatedRows.push({
                id: dependencyV2.id, name: dependencyV2.name,
                criteriaCount: dependencyV2.criteria
                    ? dependencyV2.criteria.reduce((result, {length}) => result + length, 0)
                    : 0
            });
        }
        return calculatedRows;
    }

    async getDependencyParticipantActivityId(eventId: string) {
        return await getDependencyEventActivityIds(eventId, {
            apiSvc: this.apiSvc,
            sharedSvc: this.sharedSvc
        });
    }

    async getDependencyEventProductFields(eventId: string) {
        return await getDependencyEventProductFields(eventId, {
            apiSvc: this.apiSvc,
            sharedSvc: this.sharedSvc
        });
    }

    getDependencyWorkflow() {
        return getDependencyWorkflow({sharedSvc: this.sharedSvc});
    }
}
